/**
 * HOC which passes down width and height of parent
 * May have width, height as props and it will have priority
 */
import React from 'react';

function getDisplayName(WrappedComponent: any) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

interface IWithDimensionState {
  width: number;
  height: number;
  hidden: boolean;
}

const withDimensions = (WrappedComponent: any) => {
  class WithDimensions extends React.Component<any, IWithDimensionState> {
    static displayName: string;
    ref: any;
    updateEnd: any;

    constructor(props: any) {
      super(props);

      this.ref = React.createRef();
      this.state = {
        width: 0,
        height: 0,
        hidden: false,
      };
    }

    componentDidMount() {
      this.updateDimensions();
      window.addEventListener('grid', this.updateStart, false);
      window.addEventListener('resize', this.updateStart, false);
    }

    componentWillUnmount() {
      window.removeEventListener('grid', this.updateStart);
      window.removeEventListener('resize', this.updateStart);
    }

    updateDimensions = () => {
      const width = this.ref.current?.offsetWidth;
      const height = this.ref.current?.offsetHeight - 22;

      this.setState({
        hidden: false,
        width,
        height,
      });
    };

    /**
     * Hide chart on resize
     */
    updateStart = () => {
      this.setState({ hidden: true });
      this.updateEnd = setTimeout(this.updateDimensions, 200);
    };

    render() {
      const { maxHeight, maxWidth } = this.props;
      return (
        <div ref={this.ref} style={{ maxHeight, height: '100%', maxWidth }}>
          <WrappedComponent
            width={this.state.width}
            height={this.state.height}
            {...this.props}
          />
        </div>
      );
    }
  }

  WithDimensions.displayName = `WithDimensions(${getDisplayName(
    WrappedComponent
  )})`;

  return WithDimensions;
};

export default withDimensions;
